// extracted by mini-css-extract-plugin
export var breadcrumb = "_19-0";
export var breadcrumbArrow = "_19-1";